var window=global;var $CLJS=require("./cljs_env.js");require("./cljs.core.js");require("./cljs.core.match.js");require("./metabase.mbql.util.match.impl.js");
'use strict';